import { FormInput, FormInputProps } from 'modules';
import React from 'react';

const RodinnyStavSelect = (props: FormInputProps) => {
  const options = [
    {
      label: 'Slobodný',
      value: 'Slobodný',
    },
    {
      label: 'Slobodná',
      value: 'Slobodná',
    },
    {
      label: 'Ženatý',
      value: 'Ženatý',
    },
    {
      label: 'Vydatá',
      value: 'Vydatá',
    },
    {
      label: 'Rozvedený',
      value: 'Rozvedený',
    },
    {
      label: 'Rozvedená',
      value: 'Rozvedená',
    },
    {
      label: 'Vdovec',
      value: 'Vdovec',
    },
    {
      label: 'Vdova',
      value: 'Vdova',
    },
  ];

  return <FormInput {...props} type={'select'} options={options} />;
};

export default RodinnyStavSelect;
